import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';

import {
  SET_MFA_METHODS,
  SET_MFA_SETTINGS,
  ON_METHOD_STATUS_CHANGE
} from './mutationTypes';

export default {
  [SET_MFA_METHODS](state, twoFactorMethods) {
    if (twoFactorMethods && Array.isArray(twoFactorMethods)) {
      state.twoFactorMethodsList = twoFactorMethods;
    }
  },

  [SET_MFA_SETTINGS](state, mfaSettings) {
    state.mfaSettings = mfaSettings;
  },

  [ON_METHOD_STATUS_CHANGE](state, { type, status }) {
    state.twoFactorMethodsList.forEach(twofaProvider => {
      if (twofaProvider.type === type) {
        twofaProvider.isEnabled = status;
      }
    });
  },

  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
};